import PERMISSIONS_LIST from '../../../../../submodules/web-shared/modules/Permissions/permissions-list';
import { portalLevelPermissions } from '../../../../../submodules/web-shared/modules/Permissions/PortalLevelPermissions';
import { useUserCompanies } from '../../../../../submodules/web-shared/reducers/user-companies/hooks';
import { COMPANY_SETTING_NAME } from '../../../../global/modules/companies/api/company-settings/enums/company-settings';

export const useInventoryPageAccess = () => {
  const { isCompanySettingEnabled } = useUserCompanies();

  const hasPermission = (permission: PERMISSIONS_LIST) => {
    return portalLevelPermissions.isPermissionEnabled(permission, null);
  };

  /**
   * Determines if user can access the Inventory Management application
   */
  const isInventoryManagementEnabled = () => {
    return isCompanySettingEnabled(COMPANY_SETTING_NAME.INVENTORY_PAGE_ACCESS);
  };

  /**
   * Determines if user can access the Catalog section of the Inventory Management application
   */
  const hasCatalogAccess = () => {
    return isInventoryManagementEnabled() &&
      hasPermission(PERMISSIONS_LIST.view_consumable_items);
  };

  /**
   * Determines if user can manage the Catalog section of the Inventory Management application
   */
  const hasManageCatalogAccess = () => {
    return isInventoryManagementEnabled() &&
      hasPermission(PERMISSIONS_LIST.manage_consumable_items);
  };

  /**
   * Determines if user can access the Inventory section of the Inventory Management application
   */
  const hasInventoryAccess = () => {
    return isInventoryManagementEnabled() &&
      hasPermission(PERMISSIONS_LIST.view_consumable_inventory);
  };

  /**
   * Determines if user can manage the Inventory section of the Inventory Management application
   */
  const hasManageInventoryAccess = () => {
    return hasInventoryAccess() &&
      hasPermission(PERMISSIONS_LIST.manage_consumable_inventory);
  };

  /**
   * Determines if user can access the My Network section of the Inventory Management application
   */
  const hasMyNetworkAccess = () => {
    return isInventoryManagementEnabled() &&
      hasPermission(PERMISSIONS_LIST.view_consumable_inventory_network);
  };

  const hasInventoryManagementAccess = () => {
    return (
      hasCatalogAccess() ||
      hasInventoryAccess() ||
      hasMyNetworkAccess()
    );
  };

  return {
    hasCatalogAccess,
    hasManageCatalogAccess,
    hasInventoryAccess,
    hasManageInventoryAccess,
    hasMyNetworkAccess,
    hasInventoryManagementAccess,
  };
};